import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState(location.state?.user ? "auth" : "checking");
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    if (location.state?.user) return;
    if (window.location.hash?.includes("session_id=")) return;
    const check = async () => {
      try {
        const res = await fetch(`${API}/auth/me`, { credentials: "include" });
        if (!res.ok) throw new Error("not authenticated");
        const data = await res.json();
        setUser(data);
        setStatus("auth");
      } catch {
        setStatus("guest");
      }
    };
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (status === "guest") navigate("/login", { replace: true });
  }, [status, navigate]);

  if (status !== "auth") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink" data-testid="auth-loading">
        <p className="text-sm font-bold tracking-[0.3em] text-white/50">WIRD GELADEN…</p>
      </div>
    );
  }
  return children(user);
};
